import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface JudgeMeReview {
  id: number;
  rating: number;
  title: string;
  body: string;
  reviewer_name: string;
  product_title: string;
  product_handle: string;
  created_at: string;
}

async function fetchReviews(productHandle?: string): Promise<JudgeMeReview[]> {
  const options: { body?: { product_handle: string } } = {};
  if (productHandle) {
    options.body = { product_handle: productHandle };
  }

  const { data, error } = await supabase.functions.invoke('judgeme-reviews', options);
  if (error) throw error;
  return data?.reviews || [];
}

export function useJudgeMeReviews(productHandle?: string) {
  return useQuery({
    queryKey: ['judgeme-reviews', productHandle || 'all'],
    queryFn: () => fetchReviews(productHandle),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
